module.exports = __webpack_public_path__ + "fonts/Arial-Rounded-MT-Bold-Font.92db065.ttf";